import React from 'react'
import PropTypes from 'prop-types'
import { QRCodeSVG } from 'qrcode.react'

/**
 * In-portal QRIS. The payer scans this instead of being bounced to the gateway's
 * hosted checkout page. Two shapes, because the two gateways return the QR
 * differently:
 *   - qrString : raw EMVCo QRIS payload (Xendit) — drawn client-side, no fetch.
 *   - qrUrl    : a URL to a ready-made QR image (Midtrans Core API) — <img>.
 * At most one is set; render whichever we got. Renders nothing when neither is.
 */
function PaymentQr({ qrString, qrUrl, size, caption }) {
  if (!qrString && !qrUrl) return null
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-lg border border-gray/200 bg-white py-6">
      <div className="rounded-lg border border-gray/200 bg-white p-3">
        {qrString ? (
          <QRCodeSVG
            value={qrString}
            size={size}
            fgColor="#000000"
            bgColor="#ffffff"
            level="M"
            includeMargin={false}
          />
        ) : (
          <img
            src={qrUrl}
            alt="QRIS"
            width={size}
            height={size}
            style={{ width: size, height: size }}
          />
        )}
      </div>
      {caption ? (
        <p className="max-w-[240px] text-center text-sm-regular text-gray/600">{caption}</p>
      ) : null}
    </div>
  )
}

PaymentQr.propTypes = {
  qrString: PropTypes.string,
  qrUrl: PropTypes.string,
  size: PropTypes.number,
  caption: PropTypes.string,
}

PaymentQr.defaultProps = {
  qrString: null,
  qrUrl: null,
  size: 220,
  caption: 'Scan this QR with any bank or e-wallet app that supports QRIS.',
}

export default PaymentQr
